import { Box } from '@mui/material';
import React, { useState } from 'react';
import { KitButton, KitCard, KitList, KitPill } from '../common/MobileKit';
import { MobileListRow } from '../common/MobileCrud';
import { KitEmptyNote } from '../common/MobileDashboardKit';

/**
 * Peças do Relatório de Checklist no shell mobile (lista de modelos e modelos nunca utilizados).
 * Só apresentação: dados e ações vêm de `pages/reports/ChecklistReport.js`.
 */

const twoLines = (first, second) => (
    <>
        <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{first}</Box>
        {second ? <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{second}</Box> : null}
    </>
);

// Lista de modelos de checklist (mesmas colunas do desktop), com "Carregar mais"; toque abre o histórico.
export function ChecklistModelList({ rows, onOpen, pageSize = 20 }) {
    const [visible, setVisible] = useState(pageSize);
    if (rows.length === 0) return <KitCard><KitEmptyNote>Nenhum checklist encontrado</KitEmptyNote></KitCard>;
    const shown = rows.slice(0, visible);
    return (
        <>
            <KitList>
                {shown.map((row) => {
                    const groups = row.inspection_groups_count || 0;
                    const fills = row.times_used_in_service_order || 0;
                    return (
                        <MobileListRow
                            key={row.id}
                            title={row.checklist_name || '—'}
                            sub={twoLines(
                                row.description,
                                `${groups} ${groups === 1 ? 'grupo' : 'grupos'} · Por ${row.mechanic || '—'}`,
                            )}
                            end={(
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
                                    <KitPill tone={fills ? 'info' : undefined}>{fills}</KitPill>
                                    <Box sx={{ fontSize: 10.5, color: 'text.disabled', lineHeight: 1.4 }}>{fills === 1 ? 'preenchimento' : 'preenchimentos'}</Box>
                                </Box>
                            )}
                            chevron
                            onClick={() => onOpen(row)}
                        />
                    );
                })}
            </KitList>
            <Box sx={{ textAlign: 'center', fontSize: 12, color: 'text.disabled', m: '10px 0 6px', lineHeight: 1.4 }}>
                Exibindo {shown.length} de {rows.length} checklists
            </Box>
            {visible < rows.length && (
                <KitButton block sx={{ width: '100%' }} onClick={() => setVisible((v) => v + pageSize)}>Carregar mais</KitButton>
            )}
        </>
    );
}

// "Modelos nunca utilizados": checklist, descrição e grupos de inspeção.
export function NeverUsedList({ rows }) {
    if (rows.length === 0) {
        return <KitCard><KitEmptyNote>Nenhum modelo sem uso. Todos os modelos filtrados já foram utilizados em ao menos uma OS</KitEmptyNote></KitCard>;
    }
    return (
        <KitList>
            {rows.map((row) => (
                <MobileListRow
                    key={row.id}
                    title={row.checklist_name}
                    sub={row.description || '—'}
                    end={<Box sx={{ fontWeight: 800, fontSize: 14, lineHeight: 1.4 }}>{row.inspection_groups_count || 0} {(row.inspection_groups_count || 0) === 1 ? 'grupo' : 'grupos'}</Box>}
                />
            ))}
        </KitList>
    );
}
